<template>
    <sui-modal
      id="complexTaskFlowModal"
      :open="isOpen"
      v-if="task && task != {}"
    >
      <sui-modal-header>
        Komplekst opgaveforløb for opgave #{{ task.number }}
      </sui-modal-header>
      <sui-modal-content>
        <div v-if="modalState.state.currState == 'reinstatementOrReblow'">
          <sui-button 
            @click.prevent="() => {
              modalState.transition('reblow')
              noteText = reblowBaseNoteText
            }"
            fluid
          >Kan løses af FiberLAN</sui-button>

          <div style="margin-top: 10px;"></div>

          <sui-button 
            @click.prevent="() => {
              modalState.transition('reinstatement')
              noteText = reinstatementBaseNoteText
            }"
            fluid
            basic
          >Behov for hjælp fra graveentreprenør</sui-button>
        </div>

        <div v-if="modalState.state.currState == 'reinstatement'">
          <div v-if="reinstatementFlow.state.currState == 'inform'">
            <p>
              <strong>Tag billeder af opgaven</strong><br>
              Tag billeder der dokumenterer udfordringen med opgaven, så EFB Drift har dokumentation for udfordringen<br>
              Disse billeder uploades i næste trin
            </p>
            <p>
              <strong>Informér EFB Drift om udfordringen</strong><br>
              Ring til driften på tlf. <a href="tel:+4563173222">+45 63 17 32 22</a><br>
              Installationsnummer: {{ getConfigurationLabel(task) }}<br>
            </p>

            <p>
              <strong>Informér kunden</strong><br>
              Informér kunden om, at EFB kontakter service provider for at de kan lave en ny aftale med kunden omkring ordren<br>
              Bed også kunden om at kontakte sin service provider, hvis de ikke hører fra dem
            </p>

            <p><strong>Jeg bekæfter at have gjort ovenstående</strong></p>

            <sui-button 
              @click.prevent="reinstatementFlow.transition('next')"
              fluid
              style="margin-top: 10px;"
            >Bekræft</sui-button>
          </div>
          <div v-if="reinstatementFlow.state.currState == 'noteOnTask'">
            <p>Skriv note omkring udfordringen</p>
            
            <sui-form>
              <sui-message class="ui negative message"> Eksterne noter kan ses af vores samarbejdspartnere, derfor må de ikke indeholde person data</sui-message>
              <sui-form-field>
                <label>Note tekst</label>
                <textarea rows="5" v-model="noteText"></textarea>
              </sui-form-field>
            </sui-form>

            <sui-button 
              @click.prevent="() =>{ 
                reinstatementFlow.transition('next')
              }"
              :disabled="!noteText"
              fluid
              style="margin-top: 10px;"
            >Tilføj note til opgave</sui-button>
          </div>

          <div v-if="reinstatementFlow.state.currState == 'attachmentsOnTask'">
            <p>Tilføj relevante billeder til opgaven for dokumentation</p>

            <p v-if="uploadedFileNames.length">Billeder ({{ uploadedFileNames.length }})</p>
            <ul>
              <li v-for="(fileName, index) in uploadedFileNames" :key="index">{{ fileName }}</li>
            </ul>

            <sui-form>
              <sui-form-field>
                <label>Navngiv den uploadede fil</label>
                <input type="text" placeholder="FilNavn" v-model="fileNameInput"/>
              </sui-form-field>
              <sui-form-field>
                <input :disabled="localStorageFull" type="file" @change="setFileUpload"/>
              </sui-form-field>
              <sui-message> Uploadede filer sendes til PilotBI </sui-message>
              <sui-message v-if="localStorageFull" class="ui negative message"> Der er ikke plads til flere billeder, skal der uploades flere kan dette gøres bagefter </sui-message>
              <sui-button 
                @click.prevent="addAndUploadImage()"
                :disabled="!fileUpload || localStorageFull"
                fluid
                style="margin-top: 10px;"
              >Upload og tilføj flere</sui-button>
              <sui-button 
                @click.prevent="addAndUploadImage(true)"
                :disabled="!fileUpload || localStorageFull"
                fluid
                basic
                style="margin-top: 10px;"
              >Upload og fortsæt</sui-button>
              <sui-button 
                v-if="uploadedFileNames.length"
                :disabled="!!fileUpload && !localStorageFull"
                @click.prevent="() => {
                  reinstatementFlow.transition('next')
                  cancelAppointment();
                }"
                fluid
                style="margin-top: 10px;"
              >Fortsæt</sui-button>
            </sui-form>
          </div>
        </div>

        <div v-if="modalState.state.currState == 'reblow'">
          <div v-if="reblowFlow.state.currState == 'noteOnTask'">
            <p>
              Skriv note omkring udfordringen<br>
              Beskriv også venligst årsagen til brud på SLA
            </p>
            
            <sui-form>
              <sui-message class="ui negative message"> Eksterne noter kan ses af vores samarbejdspartnere, derfor må de ikke indeholde person data</sui-message>
              <sui-form-field>
                <label>Note tekst</label>
                <textarea rows="5" v-model="noteText"></textarea>
              </sui-form-field>
            </sui-form>

            <sui-button 
              @click.prevent="() =>{ 
                reblowFlow.transition('next')
              }"
              :disabled="!noteText"
              fluid
              style="margin-top: 10px;"
            >Tilføj note til opgave</sui-button>
          </div>

          <div v-if="reblowFlow.state.currState == 'solveWithinConnectionDate'">
            <p>
              Kan udfordringen løses indenfor den nuværende connection date?<br>
              Connection date: {{ toUserFriendlyDate(task.connectionDate) }}
            </p>

            <sui-button 
              @click.prevent="() => {
                reblowFlow.transition('yes')
                performCpeOnHold()
              }"
              fluid
            >Ja</sui-button>

            <div style="margin-top: 10px;"></div>

            <sui-button 
              @click.prevent="reblowFlow.transition('no')"
              fluid
              basic
            >Nej</sui-button>
          </div>

          <div v-if="reblowFlow.state.currState == 'immediateRebooking'">
            <sui-button 
              @click.prevent="reblowFlow.transition('yes')"
              fluid
              style="margin-top: 10px;"
            >Book om med det samme</sui-button>
            <div style="margin-top: 10px;"></div>
            <sui-button 
              @click.prevent="() => {
                reblowFlow.transition('no')
                cancelAppointment();
              }"
              fluid
              basic
            >Bookes senere</sui-button>
          </div>

          <div v-if="reblowFlow.state.currState == 'rebooking'">
            <p>
              Du kan nu ombooke aftalen når denne modal er lukket.<br>
              Klik på knappen nedenfor for at bekræfte at du opdaterer aftalen efter lukning af modal.
            </p>
            <p>
              <strong>Husk at ombooke aftalen efter lukning af modal!</strong>
            </p>
            <sui-button 
              @click.prevent="updateAppointment()"
              fluid
              style="margin-top: 10px;"
            >Jeg bekræfter</sui-button>

          </div>

          <div v-if="reblowFlow.state.currState == 'createTicket'">
            <p>
              Opret ticket til FiberLAN drift omkring udfordringen<br>
            </p>
            <sui-form>
              <sui-form-field>
                <label>Kort beskrivelse (Overskrift på ticket)</label>
                <input type="text" placeholder="Kort beskrivelse af udfordringen" v-model="ticketShortDescription"/>
              </sui-form-field>
              <sui-form-field>
                <label>Detaljeret beskrivelse</label>
                <textarea rows="5" v-model="ticketDescription" placeholder="Detaljeret beskrivelse af udfordringen og hvad der er forsøgt"></textarea>
              </sui-form-field>
            </sui-form>
            <sui-button 
              @click.prevent="createTicket()"
              :disabled="!ticketShortDescription || !ticketDescription"
              fluid
              style="margin-top: 10px;"
            >Opret ticket</sui-button>
          </div>
        </div>

        <div v-if="modalState.state.currState == 'completed'">
          <h3>Alle trin i opgaveforløbet er fuldført</h3>
          <p>Klik på "Gem" for at lukke modal og gemme ændringer</p>
        </div>
        <sui-dimmer :active="stateFormLoading">
          <multi-step-loader
            class="content"
            :steps="loadingSteps"
          />
        </sui-dimmer>
      </sui-modal-content>

      <sui-modal-actions>
        <sui-button 
          basic
          @click="clickAway()"
        >Luk</sui-button>
        <sui-button 
          v-if="modalState.state.currState == 'completed'"
          @click="completeAllJobs()"
        >Gem</sui-button>
      </sui-modal-actions>
    </sui-modal>
</template>

<script>
import EventBus from '@/EventBus';
import { mapGetters } from 'vuex'
import FiniteStateMachine from '../../lib/Enums/FiniteStateMachine';
import { Mixin } from '@/lib/Mixins/mixin';
import { DateMixin } from '../../lib/Mixins/dateMixin';
import { createTicketMixin } from '../../lib/Mixins/createTicketMixin';
import { Bookingmixin } from '../../lib/Bookingmixin';
import { DataAPI } from '@/lib/DataAPI.js';
import TaskState from '@/lib/Enums/TaskState.js';
import AppointmentType from '@/lib/Enums/AppointmentType.js';
import TaskCode from '@/lib/Enums/TaskCode.js';

import MultiStepLoader from '../Global/MultiStepLoader.vue'

export default {
  mixins: [Mixin, DateMixin, createTicketMixin, DataAPI, Bookingmixin],

  enums: {
    TaskState,
    AppointmentType,
    TaskCode,
  },

  components: {
    MultiStepLoader,
  },

  props: {
    isOpen: Boolean,
    installationLabel: String,
    installation: Object,
    task: Object,
    activeProject: Object,
  },

  data() {
    return {
      stateFormLoading: false,
      localStorageFull: false,
      loadingSteps: [],
      jobs: [],
      notesCount: 0,

      noteText: '',
      reinstatementBaseNoteText: '', // Possible predefined text for reinstatement notes
      reblowBaseNoteText: '', // Possible predefined text for reblow notes

      reInstatementOnHoldReason: 'Awaiting Vendor',
      reInstatementOnHoldSubreason: 'Afventer SP - se ticket',
      reblowOnHoldReason: 'Awaiting Problem',
      reblowOnHoldSubreason: 'Afklaring etablering',
      reblowSlaBreachReason: 'Efter ønske fra kunden',


      fileNameInput: null,
      fileUpload: null,
      uploadedFileNames: [],

      ticketShortDescription: '',
      ticketDescription: '',

      modalState: new FiniteStateMachine('reinstatementOrReblow', {
        reinstatementOrReblow: {
          reinstatement: 'reinstatement', // When the reinstatement event occurs, go to reinstatement
          reblow: 'reblow', // When the reblow event occurs, go to reblow
        },
        reinstatement: {
          complete: 'completed',
        },
        reblow: {
          complete: 'completed',
        },
        completed: {
          // No further transitions
        },
      }),

      reinstatementFlow: new FiniteStateMachine('inform', {
        // Kontakt FiberDrift om udfordringen
        // Informer kunden om, at EFB kontakter Sp for at de kan lave en ny aftale med kunden omkring ordren
        inform: {
          next: 'noteOnTask',
        },
        // Lav en kommentar på opgaven omkring omgravningen / genetableringen
        noteOnTask: {
          next: 'attachmentsOnTask',
        },
        // Tilføj relevante billeder til opgaven for dokumentation
        attachmentsOnTask: {
          next: 'autoCompletionFlow',
        },
        // Automatisk færdigmelding af opgaven (bliver nok vores aflysningsflow)
        // 1. delete connection date
        // 2. bookkunde -> on hold ( awaiting vendor - afventer sp se ticket)
        autoCompletionFlow: {
          next: 'completed',
        },
        completed: {
          // No further transitions from completed
        },
      }),

      reblowFlow: new FiniteStateMachine('noteOnTask', {
        noteOnTask: {
          next: 'solveWithinConnectionDate',
        },
        solveWithinConnectionDate: {
          yes: 'cpeOnHold',
          no: 'immediateRebooking',
        },
        cpeOnHold: {
          next: 'createTicket',
        },
        bookkundeOnHold: {
          next: 'createTicket',
        },
        immediateRebooking: {
          yes: 'createTicket',
          no: 'deleteConnectionDate',
        },
        deleteConnectionDate: {
          next: 'bookkundeOnHold',
        },
        rebooking: {
          next: 'completed',
        },
        createTicket: {
          next: 'completed',
          rebook: 'rebooking',
        },
        completed: {
          // No further transitions from completed
        },
      }),

    };
  },

  computed: {
    ...mapGetters({
      firebaseUser: 'userProfile'
    }),
},

  methods: {
    clickAway() {
      this.modalState.resetFSM();
      this.reinstatementFlow.resetFSM();
      this.reblowFlow.resetFSM();
      this.noteText = '';
      this.fileNameInput = null;
      this.fileUpload = null;
      this.loadingSteps = [];
      this.jobs = [];
      this.ticketShortDescription = '';
      this.ticketDescription = '';
      this.localStorageFull = false;
      this.stateFormLoading = false;
      this.notesCount = 0;
      
      for (const i in this.uploadedFileNames) {
        console.log("Removing uploaded image from localStorage:", this.uploadedFileNames[i])
        const imageId = `uploadImage_${i}` // Placeholder image ID
        window.localStorage.removeItem(imageId)
      }
      this.uploadedFileNames = [];

      EventBus.$emit('close-complex-task-flow-modal')
    },

    changeLoadingStep(code, state){
      let stepIndex = this.loadingSteps.findIndex(step => step.code == code)
      if (stepIndex == -1) {
        console.error(`Could not find step with code ${code} in this.loadingSteps`)
        return
      }
      let stepObj = this.loadingSteps[stepIndex]
      stepObj.state = state
      this.$set(this.loadingSteps, stepIndex, stepObj)
      return stepObj
    },

    async cancelAppointment() {
      if (this.modalState.state.currState == 'reinstatement' && this.reinstatementFlow.state.currState !== 'autoCompletionFlow') {
        console.error("Not in autoCompletionFlow state", this.reinstatementFlow.state.currState)
        return
      }

      if (this.modalState.state.currState == 'reblow' && this.reblowFlow.state.currState !== 'deleteConnectionDate') {
        console.error("Not in deleteConnectionDate state", this.reblowFlow.state.currState)
        return
      }

      let onHoldReason = null
      let onHoldSubreason = null
      if (this.modalState.state.currState == 'reinstatement') {
        onHoldReason = this.reInstatementOnHoldReason
        onHoldSubreason = this.reInstatementOnHoldSubreason
      } else if (this.modalState.state.currState == 'reblow') {
        onHoldReason = this.reblowOnHoldReason
        onHoldSubreason = this.reblowOnHoldSubreason
      }

      this.loadingSteps.push({ code: 'deleteConnectionDate', title: 'Sletter connection date', state: 'pending' })
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep('deleteConnectionDate', 'in progress');
        //   setTimeout(() => { 
        //     console.group("Deleting connection date...")
        //     console.log("Task id:", this.task.id)
        //     console.log("...connection date deleted.")
        //     console.groupEnd()
        //     this.changeLoadingStep('deleteConnectionDate', 'success'); 
        //     resolve(); 
        //   }, 1500);
        // })      

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep('deleteConnectionDate', 'in progress');
          console.group("Deleting connection date...")
          console.log("Task id:", this.task.id)
         
          this.dataDeleteConnectionDate(this.task.id)
            .then(() => {
              console.log("...connection date deleted.")
              console.groupEnd();
              this.changeLoadingStep('deleteConnectionDate', 'success'); 
              resolve();
            })
            .catch((error) => {
              console.error("Error deleting connection date:", error);
              console.groupEnd();
              this.changeLoadingStep('deleteConnectionDate', 'error'); 
              reject(error);
            });
        })
      });

      const activeAppointment = Object.keys(this.installation.appointments || {})
        .map(key => ({ ...this.installation.appointments[key], id: key }))
        .sort((a, b) => new Date(a.Date) - new Date(b.Date))
        .find(app => app.State === 'active')

      if (!activeAppointment) {
        console.warn("No active appointment found for installation", this.installation)
        this.createNote();
        this.bookTaskOnHold(onHoldReason, onHoldSubreason);
      } else {
        this.loadingSteps.push({ code: 'deleteAppointment', title: 'Sletter aftale', state: 'pending' })

        this.jobs.push(() => {
          // TESTING MOCKUP
          // return new Promise(resolve => {
          //   this.changeLoadingStep('deleteAppointment', 'in progress');

          //   const appointmentTasksModel = AppointmentType.AppointmentTasks[activeAppointment.AppointmentType];
          //   const bookTask = activeAppointment.ProjectTasks?.find(t => TaskCode.taskHasCode(t, appointmentTasksModel.book.taskCode));
          //   const bookTaskFromInst = this.installation.tasks.find(t => t.id == bookTask?.Id)

          //   console.group("Deleting appointment...")
          //   console.log("Book task:", bookTaskFromInst)
          //   console.log("Primary task:", this.task)
          //   console.log("Appointment:", activeAppointment)
          //   console.log("Installation:", this.installation)
          //   console.log("User:", this.firebaseUser)
          //   console.log("Reason:", this.noteText)
          //   console.log("On hold reason:", onHoldReason)
          //   console.log("On hold subreason:", onHoldSubreason)
          //   console.log("...appointment deleted.")
          //   console.groupEnd()
          //   setTimeout(() => { 
          //     this.changeLoadingStep('deleteAppointment', 'success'); 
          //     resolve(); 
          //   }, 2000);
          // })

          // PRODUCTION CODE
          return new Promise((resolve, reject) => {
            this.changeLoadingStep('deleteAppointment', 'in progress');
            const appointmentTasksModel = AppointmentType.AppointmentTasks[activeAppointment.AppointmentType];
            const bookTask = activeAppointment.ProjectTasks?.find(t => TaskCode.taskHasCode(t, appointmentTasksModel.book.taskCode));
            const bookTaskFromInst = this.installation.tasks.find(t => t.id == bookTask?.Id);

            console.group("Deleting appointment...")
            console.log("Book task:", bookTaskFromInst)
            console.log("Primary task:", this.task)
            console.log("Installation:", this.installation)
            console.log("User:", this.firebaseUser)
            console.log("Reason:", this.noteText)
            console.log("On hold reason:", onHoldReason)
            console.log("On hold subreason:", onHoldSubreason)

            this.dataDeleteAppointment(
              activeAppointment,
              bookTaskFromInst,
              this.task,
              this.firebaseUser,
              this.noteText,
              true, // setOnHold
              onHoldReason,
              onHoldSubreason
            ).then(() => {
              console.log("...appointment deleted.")
              console.groupEnd();
              this.changeLoadingStep('deleteAppointment', 'success'); 
              resolve();
            })
            .catch((error) => {
              console.error("Error deleting appointment:", error);
              console.groupEnd();
              this.changeLoadingStep('deleteAppointment', 'error'); 
              reject(error);
            });
          });
        });
      }

      if (this.modalState.state.currState == 'reblow') {
        this.reblowFlow.transition('next');
        this.reblowFlow.transition('next');
      }

      if (this.modalState.state.currState == 'reinstatement') {
        this.modalState.transition('complete');
      }
    },

    async createNote(noteType = 'Ekstern') {
      this.notesCount += 1;
      const noteId = `createNote_${this.notesCount}` // Placeholder note ID
  
      this.loadingSteps.push({ code: noteId, title: `Opretter ${noteType.toLowerCase()} note på opgave`, state: 'pending' })
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep(noteId, 'in progress');
        //   console.group("Creating note on task...")
        //   console.log("Task id:", this.task.id)
        //   console.log("Installation label:", this.installationLabel)
        //   console.log("Note type:", noteType)
        //   console.log("Note text:", this.noteText)
        //   console.log("Active project id:", this.activeProject.id)
        //   console.log("...note created.")
        //   console.groupEnd()
        //   setTimeout(() => { 
        // this.changeLoadingStep(noteId, 'success'); 
        // resolve(); 
        //   }, 2000);
        // })

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep(noteId, 'in progress');
          console.group("Creating note on task...")
          console.log("Task id:", this.task.id)
          console.log("Installation label:", this.installationLabel)
          console.log("Note type:", noteType)
          console.log("Note text:", this.noteText)
          console.log("Active project id:", this.activeProject.id)
         
          this.dataPostNote(this.task.id, this.installationLabel, this.noteText, noteType, this.activeProject.id, false)
            .then((response) => {
              console.log("Note created with response:", response);
              this.changeLoadingStep(noteId, 'success'); 
              console.log("...note created.")
              console.groupEnd();
              resolve();
            })
            .catch((error) => {
              console.error("Error creating note:", error);
              console.groupEnd();
              this.changeLoadingStep(noteId, 'error'); 
              reject(error);
            });
        })
      });
    },

    async createTicket() {

      if (this.reblowFlow.state.prevState === 'immediateRebooking') {
        this.createNote();
      }

      this.loadingSteps.push({ code: 'createTicket', title: 'Opretter ticket til FiberDrift', state: 'pending' })
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep('createTicket', 'in progress');
        //   const ticketData = this.createTicketFromTask(this.task, this.ticketShortDescription, this.ticketDescription, this.firebaseUser)
        //   console.group("Creating ticket...")
        //   console.log("Ticket data:", ticketData)

        //   console.log("...ticket created.")
        //   const response = '123456' // Placeholder ticket ID
        //   this.noteText = `Der er oprettet en Ticket ifm. konverteringen på: ${this.installationLabel}\nTask id: ${this.task.id}\nTicket id: ${response}`
        //   console.groupEnd()
        //   setTimeout(() => { 
        // this.changeLoadingStep('createTicket', 'success'); 
        // resolve(); 
        //   }, 2000);
        // })

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep('createTicket', 'in progress');
          const ticketData = this.createTicketFromTask(this.task, this.ticketShortDescription, this.ticketDescription, this.firebaseUser);
          console.group("Creating ticket...");
          console.log("Ticket data:", ticketData);
         
          this.dataPostTroubleTicket(ticketData).then((response) => {
            console.log("Ticket created with response:", response);
            this.noteText = `Der er oprettet en Ticket ifm. konverteringen på: ${this.installationLabel}\nTask id: ${this.task.id}\nTicket id: ${response}`
            this.changeLoadingStep('createTicket', 'success'); 
            console.log("...ticket created.");
            console.groupEnd();
            resolve();
          }).catch((error) => {
            console.error("Error creating ticket:", error);
            console.groupEnd();
            this.changeLoadingStep('createTicket', 'error'); 
            reject(error);
          });
        })
      });

      this.loadingSteps.push({ code: 'addSlaBreachUpdate', title: 'Tilføjer SLA brud opdatering på installation', state: 'pending' });
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep('addSlaBreachUpdate', 'in progress');
        //   console.group("Adding SLA breach update to installation...")
        //   console.log("Installation:", this.installation)
        //   console.log("User:", this.firebaseUser)
        //   console.log("SLA breached:", true)
        //   console.log("SLA breach reason:", this.reblowSlaBreachReason)
        //   console.log("...SLA breach update added.")
        //   console.groupEnd()
        //   setTimeout(() => { 
        // this.changeLoadingStep('addSlaBreachUpdate', 'success'); 
        // resolve(); 
        //   }, 1500);
        // })

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep('addSlaBreachUpdate', 'in progress');
          console.group("Adding SLA breach update to installation...")
          console.log("Installation:", this.installation)
          console.log("User:", this.firebaseUser)
          console.log("SLA breach reason:", this.reblowSlaBreachReason)
         
          this.saveUpdateToInstallation(
            this.firebaseUser, 
            this.installation, 
            null, // selected worker
            [], // selected workers
            "ProjectBooking", // route name
            false, // flag appointment
            false, // add to cancellation list
            false, // is house association
            [], // selected tags
            true, // sla breached
            this.reblowSlaBreachReason,
          ).then(() => {
            console.log("...SLA breach update added.")
            console.groupEnd();
            this.changeLoadingStep('addSlaBreachUpdate', 'success'); 
            resolve();
          })
          .catch((error) => {
            console.error("Error adding SLA breach update:", error);
            console.groupEnd();
            this.changeLoadingStep('addSlaBreachUpdate', 'error'); 
            reject(error);
          });
        })
      });

      this.createNote('Intern');

      if (this.reblowFlow.state.prevState === 'immediateRebooking') {
        this.reblowFlow.transition('rebook');
      } else {
        this.reblowFlow.transition('next');
        this.modalState.transition('complete');
      }
    },

    async updateAppointment() {
      this.reblowFlow.transition('next');
      this.modalState.transition('complete');
    },

    async addAndUploadImage(finish = false) {
      let base64Content = await this.encodeFile(this.fileUpload)
      base64Content = String(base64Content).substring(base64Content.indexOf('base64,')+7)
      
      let fileName = this.fileNameInput
      if (!fileName) fileName = this.fileUpload.name
      
      const expectedExtension = this.getExtenstionByMimeType(this.fileUpload.type)
      const fileExtension = this.getFileExtension(fileName)
      if (fileExtension != expectedExtension) {
        fileName += `.${expectedExtension}`
      }
      const fileObject = {
        name: fileName,
        type: this.fileUpload.type,
        content: base64Content,
      }

      const imageId = `uploadImage_${this.uploadedFileNames.length}` // Placeholder image ID
      try {
        window.localStorage.setItem(imageId, JSON.stringify(fileObject))
        this.uploadedFileNames.push(fileName)
      } catch (e) {
        this.localStorageFull = true
        console.warn("LocalStorage full, cannot store image temporarily.")
        console.error("Error storing image in localStorage:", e)
        return
      }
      delete fileObject.content // Remove content from logged object

      // await this.dataPostAttachment(this.activeInstallationData.tasks[0].id, fileName, this.fileUpload.type, base64Content, false)
      this.loadingSteps.push({ code: imageId, title: 'Uploader billede', state: 'pending' })
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   const iimageFromLocalStorage = JSON.parse(window.localStorage.getItem(imageId))
        //   console.group("Uploading image...")
        //   console.log("Task id:", this.task.id)
        //   console.log("File name:", iimageFromLocalStorage.name)
        //   console.log("File type:", iimageFromLocalStorage.type)
        //   console.log("File content (base64):", iimageFromLocalStorage.content.substring(30, 60) + '...') // Log only the beginning of the content
        //   console.log("...image uploaded.")
        //   console.groupEnd()
        //   window.localStorage.removeItem(imageId)
        //   this.changeLoadingStep(imageId, 'in progress');
        //   setTimeout(() => { 
        // this.changeLoadingStep(imageId, 'success'); 
        // resolve(); 
        //   }, 3000);
        // });

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          const imageFromLocalStorage = JSON.parse(window.localStorage.getItem(imageId))
          console.group("Uploading image...")
          console.log("Task id:", this.task.id)
          console.log("File name:", imageFromLocalStorage.name)
          console.log("File type:", imageFromLocalStorage.type)
          console.log("File content (base64):", imageFromLocalStorage.content.substring(30, 60) + '...') // Log only the beginning of the content
         
          this.changeLoadingStep(imageId, 'in progress');
          this.dataPostAttachment(this.task.id, imageFromLocalStorage.name, imageFromLocalStorage.type, imageFromLocalStorage.content, false)
            .then(() => {
              console.log("...image uploaded.")
              console.groupEnd()
              window.localStorage.removeItem(imageId)
              this.changeLoadingStep(imageId, 'success'); 
              resolve(); 
            })
            .catch((error) => {
              console.error("Error uploading image:", error);
              console.groupEnd()
              this.changeLoadingStep(imageId, 'error'); 
              reject(error);
            });
        });
      });

      // Reset modal
      this.fileNameInput = null
      this.fileUpload = null

      if (finish) {
        this.reinstatementFlow.transition('next')
        this.cancelAppointment();
      }
    },

    async performCpeOnHold() {
      if (this.reblowFlow.state.currState !== 'cpeOnHold') {
        console.error("Not in cpeOnHold state", this.reblowFlow.state.currState)
        return
      }

      this.createNote();

      this.loadingSteps.push({ code: 'setCpeOnHold', title: 'Sætter CPE opgave On Hold (afventer SP)', state: 'pending' })
      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep('setCpeOnHold', 'in progress');
        //   console.group("Setting CPE task On Hold...")
        //   console.log("Task id:", this.task.id)
        //   console.log("On hold reason:", this.reblowOnHoldReason)
        //   console.log("On hold subreason:", this.reblowOnHoldSubreason)
        //   console.log("...CPE task set On Hold.")
        //   setTimeout(() => { 
        // this.changeLoadingStep('setCpeOnHold', 'success'); 
        // console.groupEnd();
        // resolve(); 
        //   }, 2000);
        // })

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep('setCpeOnHold', 'in progress');
          console.group("Setting CPE task On Hold...")
          console.log("Task id:", this.task.id)
          console.log("On hold reason:", this.reblowOnHoldReason)
          console.log("On hold subreason:", this.reblowOnHoldSubreason)
         
          this.dataUpdateProjectTask(
              this.task.id,
              this.task,
              {
                  state: TaskState.ON_HOLD,
                  assignee: null,
                  onHoldReason: this.reblowOnHoldReason,
                  onHoldSubReason: this.reblowOnHoldSubreason,
              },
              false //Do not keep connection date, as it should be removed when appointment is deleted
          ).then(() => {
              console.log("...CPE task set On Hold.")
              console.groupEnd();
              this.changeLoadingStep('setCpeOnHold', 'success'); 
              resolve();
          }).catch((error) => {
              console.error("Error setting CPE task On Hold:", error);
              console.groupEnd();
              this.changeLoadingStep('setCpeOnHold', 'error'); 
              reject(error);
          });
        })

      });
    
      this.reblowFlow.transition('next');
    },

    async bookTaskOnHold(onHoldReason, onHoldSubreason) {
      this.loadingSteps.push({ code: 'setBookTaskOnHold', title: 'Sætter bookkunde opgave On Hold (afventer SP)', state: 'pending' })

      const bookTaskFromInst = this.installation.tasks.find(t => t.code == TaskCode.BOOKKUNDE)

      this.jobs.push(() => {
        // TESTING MOCKUP
        // return new Promise(resolve => {
        //   this.changeLoadingStep('setBookTaskOnHold', 'in progress');
        //   console.group("Setting bookkunde task On Hold...")
        //   console.log("Task id:", bookTaskFromInst.id)
        //   console.log("On hold reason:", onHoldReason)
        //   console.log("On hold subreason:", onHoldSubreason)
        //   console.log("...bookkunde task set On Hold.")
        //   console.groupEnd()
        //   setTimeout(() => { 
        // this.changeLoadingStep('setBookTaskOnHold', 'success'); 
        // resolve(); 
        //   }, 2000);
        // })

        // PRODUCTION CODE
        return new Promise((resolve, reject) => {
          this.changeLoadingStep('setBookTaskOnHold', 'in progress');
          console.group("Setting bookkunde task On Hold...")
          console.log("Task id:", bookTaskFromInst.id)
          console.log("On hold reason:", onHoldReason)
          console.log("On hold subreason:", onHoldSubreason)
         
          this.dataUpdateProjectTask(
              bookTaskFromInst.id,
              bookTaskFromInst,
              {
                  state: TaskState.ON_HOLD,
                  assignee: null,
                  onHoldReason: onHoldReason,
                  onHoldSubReason: onHoldSubreason,
              },
              false //Do not keep connection date, as it should be removed when appointment is deleted
          ).then(() => {
              console.log("...bookkunde task set On Hold.")
              console.groupEnd();
              this.changeLoadingStep('setBookTaskOnHold', 'success'); 
              resolve();
          }).catch((error) => {
              console.error("Error setting bookkunde task On Hold:", error);
              console.groupEnd();
              this.changeLoadingStep('setBookTaskOnHold', 'error'); 
              reject(error);
          });
        })
      });
    },

    async completeAllJobs() {
      if (this.jobs.length == 0) {
        this.clickAway();
        return
      }
      this.stateFormLoading = true
      await this.jobs.reduce((promiseChain, currentJob) => {
        return promiseChain.then(() => currentJob());
      }, Promise.resolve());

      await new Promise(resolve => setTimeout(resolve, 500)); // Small delay to show last
      this.stateFormLoading = false
      this.clickAway();
      EventBus.$emit('reload-inst-button-click'); // Reload installation data after completing all jobs
    },

    setFileUpload(e){
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.fileUpload = null
        return false
      }
      this.fileUpload = files[0]
      return true
    },

    async encodeFile(file){
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve (reader.result)
        reader.onerror = error => reject(error)
      })
      let encodedFile = await toBase64(file).catch(e => Error(e))
      if(encodedFile instanceof Error) {
        console.error('Error encoding file: ',encodedFile.message)
        EventBus.$emit('function-activity', {functionName: 'Booking_encodeFile', isActive: false})
        return
      }
      return encodedFile
    },
  },
}

</script>